import { pbx_operators_base_breadcrumbs } from './_module';

const index = pbx_operators_base_breadcrumbs
  .extend('pbx.group.index')
  .add('pbx.breadcrumb.group.index', { name: 'pbx.group.index' });

const create = index
  .extend('pbx.group.create')
  .add('pbx.breadcrumb.group.create', { name: 'pbx.group.create' });

const edit = index
  .extend('pbx.group.edit')
  .add('pbx.breadcrumb.group.edit', { name: 'pbx.group.edit' });

export const pbx_group_breadcrumbs = [index, create, edit];
